export default __webpack_public_path__ + "static/media/sample3.5ccdac98.mp4";